import { CLIENT_URL } from '@shared/config/api/api';
import { StandardResponseType } from '@shared/types/global';

export const refreshAccessToken = async (): Promise<StandardResponseType> => {
  const response = await fetch(`${CLIENT_URL}/v2/auth/refresh`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  });

  return response.json();
};
